import { configureStore } from "@reduxjs/toolkit";
import userAuthenticationSlice from "./userAuthenticationSlice";
import roomSlice from "./roomSlice";

export const store = configureStore({
  reducer: {
    userAuth: userAuthenticationSlice,
    room: roomSlice,
  },
});
